module.exports = __webpack_public_path__ + "img/DE00857.dfa714dc.png";